import { Reveal } from "./Reveal";
import { Cog, Workflow, Handshake } from "lucide-react";

const pillars = [
  {
    icon: Cog,
    title: "Real Operations",
    text: "Built around actual motor-carrier operating experience.",
  },
  {
    icon: Workflow,
    title: "Complete System",
    text: "Multiple operating functions working together instead of disconnected vendors.",
  },
  {
    icon: Handshake,
    title: "Aligned With Ownership",
    text: "Our job is to help operate the business you own.",
  },
];

export const WhyOperator = () => {
  return (
    <section id="about" data-testid="why-section" className="bg-[#050505] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <p className="font-display text-sm font-semibold uppercase tracking-[0.3em] text-orange-500 mb-6" data-testid="why-eyebrow">
            Why I Stay Trucking
          </p>
          <h2
            className="font-display text-4xl md:text-5xl font-bold uppercase tracking-tight leading-[1.05] text-white max-w-4xl"
            data-testid="why-headline"
          >
            We Don't Just Talk About Trucking.
            <span className="block text-orange-500">We Operate Trucking Companies.</span>
          </h2>
          <p className="mt-8 max-w-2xl text-base md:text-lg text-neutral-300" data-testid="why-body">
            The I Stay Trucking model is built around real-world carrier operations. We understand
            what happens after the truck is purchased — dispatch, drivers, brokers, compliance,
            settlements, paperwork and the hundreds of operational decisions required to keep a
            trucking company moving.
          </p>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-4" data-testid="why-pillars">
          {pillars.map((p, i) => (
            <Reveal key={p.title} delay={0.08 * i}>
              <div
                data-testid={`why-pillar-${i}`}
                className="h-full border border-neutral-800 bg-[#121212] p-8 transition-all duration-200 hover:-translate-y-1 hover:border-orange-500/70"
              >
                <p.icon size={30} className="text-orange-500" strokeWidth={1.75} />
                <h3 className="mt-6 font-display text-xl md:text-2xl font-bold uppercase tracking-tight text-white">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm md:text-base text-neutral-400">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
